import createReducer from 'common/redux/utils/createReducer';
import { Map } from 'immutable';
import keyBy from 'lodash.keyby';
import { REQUEST_CATALOG, RECEIVE_CATALOG } from 'catalog/actions/catalog';
import { REQUEST_NODE, NODE_CREATED, NODE_UPDATED } from 'catalog/actions/node';
import { RECEIVE_PRODUCTS } from 'catalog/actions/product';
import { RECEIVE_PESTS } from 'catalog/actions/pest';
import { RECEIVE_TIPS } from 'catalog/actions/tip';
import { RECEIVE_MEMOS } from 'catalog/actions/memo';

const initialState = {
  isFetching: false,
  didInvalidate: false,
  isLoadingNode: false,
};

export const catalogReducer = createReducer(initialState, {
  [REQUEST_CATALOG](state, action) {
    return {
      isFetching: true,
      ...state,
    };
  },
  [RECEIVE_CATALOG](state, { nodes }) {
    const root = nodes.find(n => !n.parent);

    return {
      ...state,
      isFetching: false,
      isLoadingNode: false,
      root,
      nodes: Map(keyBy(nodes, 'id')),
    };
  },
  [REQUEST_NODE](state, { node }) {
    return {
      ...state,
      isLoadingNode: true,
    };
  },
  [NODE_CREATED](state, { node }) {
    const nodes = state.nodes.set(node.id.toString(), node);
    return {
      ...state,
      isLoadingNode: false,
      nodes,
    };
  },
  [NODE_UPDATED](state, { node }) {
    const nodes = state.nodes.set(node.id.toString(), node);
    return {
      ...state,
      isLoadingNode: false,
      nodes,
    };
  },
  [RECEIVE_PRODUCTS](state, { products }) {
    return {
      ...state,
      products,
    };
  },
  [RECEIVE_PESTS](state, { pests }) {
    return {
      ...state,
      pests,
    };
  },
  [RECEIVE_TIPS](state, { tips }) {
    return {
      ...state,
      tips,
    };
  },
  [RECEIVE_MEMOS](state, { memos }) {
    return {
      ...state,
      memos,
    };
  },
});



// WEBPACK FOOTER //
// ./src/modules/catalog/reducers/index.js